import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-FewResultsNextPagesTitle" */'@components/searchPage/FewResultsNextPagesTitle'), {
  fallbackProps: { className: 'is-hidden' },
});
